if(!customElements.get('custom-accordion')){
    class Accordion extends HTMLElement {
        constructor(){
            super();

            this.heading = this.querySelector('.accordion-heading');
            this.body = this.querySelector('.accordion-body');
            this.bodyInner = this.body?.querySelector('.accordion-body__inner');

            if (!this.heading || !this.body || !this.bodyInner) return;

            this.defaultOpen = this.dataset.defaultOpen === 'true'? true : false;

            this.body.style.height = '0px';
            this.setAttribute('data-open', 'false');

            if(this.defaultOpen){
                this.open();
            }

            this.heading.addEventListener("click", this.toggle.bind(this));
            this.heading.addEventListener("keydown", e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.toggle();
                }
            });
        }

        toggle(){
            const ifOpened = this.getAttribute('data-open') === 'true';

            if(ifOpened){
                this.close();
            }else{
                this.open();
            }
        }

        open(e){
            this.setAttribute('data-open', 'true');
            this.heading.setAttribute('aria-expanded', 'true');

            const height = this.bodyInner.scrollHeight;
            this.body.style.height = `${height}px`;
        }

        close(){
            this.setAttribute('data-open', 'false');
            this.heading.setAttribute('aria-expanded', 'false');
        
            this.body.style.height = '0px';
        }
    }

    customElements.define('custom-accordion', Accordion);
}